import {useQuery} from "@tanstack/react-query";
import {getItem} from "../../../app/getters/getItem.js";

export const usePozycjaKonfiguracji = (id, enabled = true) => {
    return useQuery({
        queryKey: [`pozycja_konfiguracji__${id}`, id],
        queryFn: () => getItem(`/config/${id}/edit`),
        enabled: enabled,
    })
}